/** Centered page width with the standard side gutter. */
export default function Container({ as: Tag = 'div', className = '', children, ...rest }) {
  return (
    <Tag className={`mx-auto w-full max-w-page px-4 sm:px-6 lg:px-10 ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
